<template>
  <div class="home">
    <h1>Welcome to Survey Form</h1>
    <h3>The form ID is invald.<br />Please correct your form ID first</h3>
  </div>
</template>
